
import styled from 'styled-components';
import { Button } from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/Tags/components/AddTagButton/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.backgrounds.primary}; 
  padding: 18px 12px 22px 20px;
  margin-top: 15px;
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  text-align: left;
  user-select: none;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.textfield.text};
`;
Title.displayName = 'Title';

export const Subtitle = styled(Title)`
  margin: 10px 0;
  font-size: 12px;
  font-weight: normal;
  color: ${({ theme }) => theme.text.modalTitle2};
`;
Subtitle.displayName = 'Subtitle';

export const EditButton = styled(Button)`
  width: 68px;
`;
EditButton.displayName = 'EditButton';

export const Entities = styled.div`
  display: flex;
  margin-top: 15px;
  & > * {
    margin-right: 15px;
  }
`;
Entities.displayName = 'Entities';
